import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ArrowWrapper = styled.span`
  fill: ${props => props.theme.carvana.blue.primary};
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

const MobileDropdownArrow = ({ isExpanded }) => {
  if (isExpanded) {
    return (
      <ArrowWrapper>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="6"
          viewBox="0 0 10 6"
        >
          <g>
            <path
              d="M0,5.19a.8.8,0,0,1,.23-.55L4.52.26A.9.9,0,0,1,5.16,0a.92.92,0,0,1,.63.28l4,4.38A.77.77,0,0,1,9.7,5.8a.87.87,0,0,1-1.2-.08L5.12,2,1.48,5.74a.88.88,0,0,1-1.21,0A.78.78,0,0,1,0,5.19"
            />
          </g>
        </svg>
      </ArrowWrapper>
    );
  }
  return (
    <ArrowWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="6"
        viewBox="0 0 10 6"
      >
        <g>
          <path
            d="M0,.81a.78.78,0,0,0,.23.55L4.52,5.74A.9.9,0,0,0,5.16,6a.88.88,0,0,0,.63-.28l4-4.38A.77.77,0,0,0,9.71.2a.88.88,0,0,0-1.2.08L5.13,4,1.48.26A.88.88,0,0,0,.27.22.78.78,0,0,0,0,.81"
          />
        </g>
      </svg>
    </ArrowWrapper>
  );
};

MobileDropdownArrow.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
};

export default MobileDropdownArrow;
